import { useLocation } from "react-router-dom";
import { Seo } from "./seo";
import { getSeoForPath } from "@/lib/seo-config";

export function RouteSeo() {
    const { pathname } = useLocation();
    const seoProps = getSeoForPath(pathname);

    return <Seo {...seoProps} canonicalPath={pathname} />;
}
